import React, { Component } from 'react';

import './TitragesAnims.css';



class TitragesAnims extends Component {


    constructor(props) {

        super(props);       
       
        this.completeTextesAnimsDefinitions(this.props.ta, this.props.id);

    }

    componentDidMount() 
    {
        /* après le premier render()  */
    }

    shouldComponentUpdate(nextProps, nextState)
    {
      /* on refresh si l'id et le contenu à changé */
      /* car l'id peut avoir déja changé via les this.setState() avant que le ta soit modifié, donc même id repassé alors qu'il faut updaté */

      if( nextProps.ta != this.props.ta )
      {
        this.completeTextesAnimsDefinitions(nextProps.ta, nextProps.id);
        return true;
      }else 
        return false;
    }
  
    completeTextesAnimsDefinitions = (ta, id) =>
    {

       /* complète le tableau g_DATA_CONFIG avec g_CONFIG_UI */ 

       this.props.logFn("TitragesAnims:completeTextesAnimsDefinitions() : "+id);
       //console.log(ta);
     
       const cfg = window.g_CONFIG_UI;
       const size_div_text = 5; /* en % = 64px environ  */
       const ph = 100 / (ta.length + 1); /* les width sont en % */
       let p0 = ph - size_div_text / 2;
     
       for(let i=0;i<ta.length;i++)  
       {
         ta[i].c = cfg.titres_anim_bkcouleurs[ta[i].bkcolor-1]
         ta[i].ct = cfg.titres_anim_texte_couleurs[ta[i].txcolor-1]
         
         let t = cfg.titres[id]; /* ### FIXME() refait à chaque render() de cet id, à voir...*/
         if(t && t.keys && (t.keys.length > 0) ) /* si config, copie les coordonnnées x/y de g_CONFIG_UI dans s.e.anim_titrage */
         {
           ta[i].x = t.keys[i].x+'%'; 
           ta[i].y = t.keys[i].y+'%';
           ta[i].r = 'rotate('+ t.keys[i].r + 'deg)';
         }else /* compute position x/y */
         {
           /*ta[i].x = w / 2;  pas de x, centrage automatique */
           ta[i].y = p0+'%';
           p0 += ph;
           /* calcul une rotation random si pas défini dans la config */
           ta[i].r = 'rotate('+parseInt(Math.random()*10 - 5,10)+'deg)';
         }
         if(cfg.titres[id])
           ta[i].direction_class = 'titre_apparition_' + cfg.titres[id].dir; /* no, left, right, top, bottom */
         else
           ta[i].direction_class = 'titre_apparition_no';         
       }   
    }

    render() {

        const ta = this.props.ta;

        let textesanims = [];
        for(let i=0;i<ta.length;i++) // if ta exist
        {
          let k = "titre"+i;
          textesanims.push( <div key= {k} style={{ 
                        top: ta[i].y, 
                        left: ta[i].x, /* si x n'existe pas, left: ne sera pas ajouté, utile pour le placement auto en width */ 
                        transform: ta[i].r
                      }} className="titre_container">
                      <div style={{ 
                          /* Pour chaque titre, on déclare deux animations à suivre (avec la même anim de @keyframe): 
                            - l'apparition, d'une durée 2s (App.css), avec un delay de ta[i].start            
                            - la disparition, est la meme anim, inversée (_out) */                            
                          animationName: ta[i].direction_class+", "+ta[i].direction_class+"_out",  /* ajouter from g_CONFIG_UI */
                          animationDuration: '0.5s, 0.5s',  
                          animationDelay: ta[i].start+"s,"+(ta[i].duration + ta[i].start)+"s",
                          animationTimingFunction: 'ease-in, ease-out',
                          animationFillMode: 'forwards, forwards'
                          }} className="titre_anim">
                        <div style={{ backgroundColor: ta[i].c }} className="titre_anim_bkg"></div>
                        <div className="titre_anim_text" style={{ color: ta[i].ct }} > 
                        {ta[i].texte.map((item, key) => {
                          return <span key={key}>{item}<br/></span> /* pour ajouter des <br/> */
                        })}
                        </div>        
                      </div>
                    </div> );
          }

        return (
            <div className='titrages_anims_container'> { textesanims } </div>
        );    
  }
}

//----------------------------------------------------------------------------

export default TitragesAnims;



// WEBPACK FOOTER //
// ./src/TitragesAnims.js